import { Actions, Nouns } from './types';

export const ACTION_TERMS = {
  [Actions.Enabled]: {
    oppositeAction: Actions.Disabled,
    pastTense: 'enabled',
  },
  [Actions.Disabled]: {
    oppositeAction: Actions.Enabled,
    pastTense: 'disabled',
  },
};

export const ADMIN_URLS = {
  production: 'admin.prd-itbl.co',
  productionEU: 'admin.eu-prd-itbl.co',
  staging: 'admin.stg-itbl.co',
  stagingEU: 'admin.eu-stg-itbl.co',
};

export const GROUP_NOUNS = {
  [Nouns.Org]: {
    plural: 'orgs',
    singular: 'org',
  },
  [Nouns.Project]: {
    plural: 'projects',
    singular: 'project',
  },
};
